<template>
  <div>
    <t-card v-loading="loading">
      <!-- 一括手配 -->
      <div :style="{ height: basicHeight + 'px', 'padding-top': '10px' }">
        <t-form label-position="right" label-width="110px">
          <t-row type="flex" justify="left">
            <t-col :span="colArr.colL">&nbsp;</t-col>

            <!-- 見積No -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.ADD_ALL_ORDER_INFO.QUOTE_NO')"
                label-width="110px"
              >
                <t-input
                  v-model="allOrderInfo.quoteNo"
                  maxLength="20"
                  style="width: 100%"
                  clearable
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 得意先 -->
            <t-col :span="colArr.colCom">
              <t-form-item :label="$t('resource.ADD_ALL_ORDER_INFO.CUS_INFO')">
                <t-input
                  v-model="allOrderInfo.cusInfo"
                  :placeholder="$t('message.NUMBER.CLICK_AND_SELECT_HINT')"
                  readonly
                  style="margin-top: 5px"
                  @click.native="customerReferenceClick()"
                >
                  <t-button
                    slot="append"
                    class="button-default custom-button"
                    icon="el-icon-circle-close"
                    @click.native.stop="clearClick"
                  ></t-button>
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 受注担当者 -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="
                  $t('resource.ADD_ALL_ORDER_INFO.ACCEPT_ORDER_CONNECTER_NAME')
                "
              >
                <t-select
                  v-model="allOrderInfo.aodConnecterName"
                  clearable
                  placeholder=""
                  style="width: 100%"
                >
                  <t-option
                    v-for="item in aodConnecterNameList"
                    :key="item.UserId"
                    :label="item.UserName"
                    :value="item.UserId"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>

            <!-- 仕入先 -->
            <t-col :span="colArr.colCom">
              <t-form-item :label="$t('resource.COMMON_CONSTANT.SUPPLIER')">
                <t-select
                  v-model="allOrderInfo.supInfoCode"
                  placeholder=""
                  clearable
                  style="width: 100%"
                >
                  <t-option
                    v-for="item in supInfoList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>

            <t-col :span="colArr.colR">&nbsp;</t-col>
          </t-row>

          <t-row type="flex" justify="left">
            <t-col :span="colArr.colL">&nbsp;</t-col>
            <!-- 受注日 -->
            <t-col :span="colArr.colCom * 2" style="height: 40px">
              <div class="button-wrapper">
                <t-form-item class="dateLabelWidth" label-width="185px">
                  <span slot="label">
                    <div>
                      <t-radio-group
                        v-model="dateLabel"
                        size="small"
                        @change="handleRadioChange"
                      >
                        <!-- 受注 -->
                        <t-radio-button label="1">
                          {{
                            $t("resource.ACCEPT_ORDER.ACCEPT_DATE")
                          }}</t-radio-button
                        >
                        <!-- 納期 -->
                        <t-radio-button label="2">{{
                          $t(
                            "resource.ADD_ALL_ORDER_INFO.CUSTOMER_DELIVERY_DATE"
                          )
                        }}</t-radio-button>
                      </t-radio-group>
                    </div>
                  </span>

                  <t-date-picker
                    v-model="dateInfo"
                    :clearable="false"
                    type="daterange"
                    class="date_icon_center"
                    range-separator="～"
                    start-placeholder="開始日"
                    end-placeholder="終了日"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    style="width: 100%"
                    :editable="false"
                  ></t-date-picker>
                </t-form-item>
              </div>
            </t-col>

            <!-- タイプ -->
            <t-col :span="colArr.colCom" class="right">
              <t-form-item :label="$t('resource.ORDER.QUOTE_TYPE')">
                <t-select
                  v-model="allOrderInfo.aodQuoteType"
                  clearable
                  placeholder=""
                  style="width: 100%"
                >
                  <t-option
                    v-for="item in aodQuoteTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>

            <t-col :span="colArr.colCom" class="right">
              <!-- <div class="button-wrapper"> -->
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                style="margin-top: 0"
                ref="searchBtn"
                @click="searchClick"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
              <!-- </div> -->
            </t-col>

            <t-col :span="colArr.colR">&nbsp;</t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row>
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="addAllOrderInfoTable"
                :data="addAllOrderInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :cell-class-name="tableCellClassName"
                highlight-current-row
                :height="detailHeight"
                @selection-change="handleRowClick"
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column
                  prop="selected"
                  type="selection"
                  class-name="cell_txt_center"
                />
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_画面と文字サイズの調整 -->
                <!-- テーブルの列 -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.minWidth"
                  :width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.minWidth"
                  :width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                  <template slot-scope="scope">
                    <t-date-picker
                      v-if="column.prop === 'orderDate'"
                      v-model="scope.row[column.prop]"
                      class="dialogDate cell_input_font_small"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :show-icon="false"
                    >
                    </t-date-picker>

                    <t-date-picker
                      v-else-if="column.prop === 'deliveryDate'"
                      v-model="scope.row[column.prop]"
                      class="dialogDate cell_input_font_small"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :show-icon="false"
                    >
                    </t-date-picker>

                  <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                  <!-- 目的港の追加 -->
                  <!-- <t-select
                    v-else-if="
                      column.prop === 'transMethod' &&
                      scope.row.supFactoryKbn === '1' &&
                      scope.row.aodQuoteType !== '3'
                    "
                    v-model="scope.row[column.prop]"
                    style="width: 100%"
                    placeholder=""
                    class="cell_input_font_small"
                  > -->
                  <t-select
                    v-else-if="
                      column.prop === 'transMethod' &&
                      scope.row.supFactoryKbn === '1' &&
                      scope.row.aodQuoteType !== '3'
                    "
                    v-model="scope.row[column.prop]"
                    style="width: 100%"
                    placeholder=""
                    class="cell_input_font_small"
                    @change="onDestPortCodeChange(scope.row, $event)"
                  >
                   <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                      <t-option
                        v-for="item in transMethodList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>

                    <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                    <!-- 目的港の追加 -->
                    <t-select
                      v-else-if="
                        column.prop === 'destPortCode' &&
                        scope.row.supFactoryKbn === '1' &&
                        scope.row.aodQuoteType !== '3' &&
                        scope.row.transMethod == '2'
                      "
                      v-model="scope.row[column.prop]"
                      style="width: 100%"
                      placeholder=""
                      class="cell_input_font_small"
                    >
                      <t-option
                        v-for="item in destinationList"
                        :key="item.dpCode"
                        :label="item.dpName"
                        :value="item.dpCode"
                      >
                      </t-option>
                    </t-select>
                    <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                    <t-select
                      v-else-if="column.prop === 'orderConnecterName'"
                      v-model="scope.row[column.prop]"
                      style="width: 100%"
                      placeholder=""
                      class="cell_input_font_small"
                    >
                      <t-option
                        v-for="item in aodConnecterNameList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <div>
            <t-col :span="20">&nbsp;</t-col>
            <t-col :span="4" align="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="checkConfirm"
                :disabled="btnClickFlg"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { httpApi } from "@/api/api";
import { ShowCustomerReferenceDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { commonApi } from "@/services/common";
import {
  cmpDetailData,
  formatDateToString,
  getAbleDestinationList,
  getAbleSupplierInfoList,
  getAbleUserInfoList,
  getDialogContentHeight,
  getEditColWidthArr,
  getNextMonthAgoArray,
  getOneMonthAgoArray,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  FACTORY_KBN_DALIAN,
  FINAL_STR,
  NUM_TWO,
  QUPTE_TYPE_CHANGE,
  STR_EMPTY,
  STR_ONE,
} from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      activeNames: ["sendBasic"],

      allOrderInfo: {
        // 見積No
        quoteNo: "",
        // 得意先
        cusInfo: "",
        // 得意先Co'de
        cusInfoCode: "",
        // 受注担当者
        aodConnecterName: "",
        // 受注日
        aodDate: "",
        // 得意先納期
        cusDeliveryDate: "",
        // 仕入先コード
        supInfoCode: "",
        // タイプ
        aodQuoteType: "",
      },

      dateInfo: [],

      supInfoList: [],

      addAllOrderInfoTable: [],

      aodConnecterNameList: [],

      aodQuoteTypeList: [],

      //輸送方式
      transMethodList: [],

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      // 目的港リスト
      destinationList: [],
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      //得意先担当者
      cusUserList: [],

      // 編集可能な列
      columnEditable: [
        "orderDate",
        "deliveryDate",
        "transMethod",
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        "destPortCode",
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        "orderConnecterName",
      ],

      //デフォルト
      dateLabel: "1",

      loading: true,

      // 確定ボタンFlag
      btnClickFlg: true,

      productBtnFlg: false,

      // ボタン表示Flag
      showFlg: false,

      buttonDisabled: true,

      //現在選択されているセル
      currentCell: [],

      // 読み込み回数
      numLoads: 1,

      // 比較用明細情報
      cmpDetailResult: {},

      // -----------------------

      maxheight: t("widgetSize.orderEditDialog.tableHeight"),
      //テーブルの列
      columns: [
        {
          // 見積No
          prop: "aobQuoteNo",
          label: t("resource.ADD_ALL_ORDER_INFO.QUOTE_NO"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.colMaxWidth"),
          // width: t("widgetSize.tableCommon.colMaxWidth"),
          minWidth: t("widgetSize.tableCommon.width110"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 区分
        {
          prop: "aobProcKbnStr",
          label: t("resource.ADD_ALL_ORDER_INFO.KBN"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.width80"),
          // width: t("widgetSize.tableCommon.width80"),
          minWidth: t("widgetSize.tableCommon.width60"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 得意先
        {
          prop: "aobCusCodeAbb",
          label: t("resource.ADD_ALL_ORDER_INFO.CUS_INFO"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.colMaxWidth"),
          // width: t("widgetSize.tableCommon.colMaxWidth"),
          minWidth: t("widgetSize.tableCommon.width120"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 受注日
        {
          prop: "aobAcceptDate",
          label: t("resource.ADD_ALL_ORDER_INFO.ACCEPT_ORDER_DATE"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.width120"),
          // width: t("widgetSize.tableCommon.width120"),
          minWidth: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 得意先納期
        {
          prop: "aobCusDeliveryDate",
          label: t("resource.ADD_ALL_ORDER_INFO.CUSTOMER_DELIVERY_DATE"),
          minWidth: t("widgetSize.tableCommon.width120"),
          // width: t("widgetSize.tableCommon.width120"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 受注担当者
        {
          prop: "aobUserCodeName",
          label: t("resource.ADD_ALL_ORDER_INFO.ACCEPT_ORDER_CONNECTER_NAME"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.colMaxWidth"),
          // width: t("widgetSize.tableCommon.colMaxWidth"),
          minWidth: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 仕入先
        {
          prop: "aobSupCodeAbb",
          label: t("resource.ADD_ALL_ORDER_INFO.SUPPLIER"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.colMaxWidth"),
          // width: t("widgetSize.tableCommon.colMaxWidth"),
          minWidth: t("widgetSize.tableCommon.width120"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // タイプ
        {
          prop: "aodQuoteTypeStr",
          label: t("resource.ORDER.QUOTE_TYPE"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.width120"),
          // width: t("widgetSize.tableCommon.width120"),
          minWidth: t("widgetSize.tableCommon.width80"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 手配日
        {
          prop: "orderDate",
          label: t("resource.ADD_ALL_ORDER_INFO.ORDER_DATE"),
          minWidth: t("widgetSize.tableCommon.width170"),
          align: "cell_txt_center",
          overflowTooltip: false,
        },
        // 仕入先納期
        {
          prop: "deliveryDate",
          label: t("resource.ADD_ALL_ORDER_INFO.DELIVERY_DATE"),
          minWidth: t("widgetSize.tableCommon.width170"),
          align: "cell_txt_center",
          overflowTooltip: false,
        },
        // 手配担当者
        {
          prop: "orderConnecterName",
          label: t("resource.ADD_ALL_ORDER_INFO.ORDER_CONNECTER_NAME"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_画面と文字サイズの調整
          // minWidth: t("widgetSize.tableCommon.width200"),
          // width: t("widgetSize.tableCommon.width200"),
          minWidth: t("widgetSize.tableCommon.width170"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center ",
          overflowTooltip: false,
        },
        // 輸送方式
        {
          prop: "transMethod",
          label: t("resource.ADD_ALL_ORDER_INFO.TRANS_METHOD"),
          minWidth: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        // 目的港
        {
          prop: "destPortCode",
          label: t("resource.ORDER.DESTINATION_PORT"),
          minWidth: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
      ],

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 2.5,

      //基本情報のheight
      basicButtonHeight: DIALOG_LINE_HEIGHT,

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 2,
        40
      ),

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    RowData: {
      Type: Object,
    },
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  created() {
    this.loading = true;

    // 見積No
    this.allOrderInfo.quoteNo = "";

    // 得意先
    this.allOrderInfo.cusInfo = "";

    // 受注担当者
    this.allOrderInfo.aodConnecterName = "";

    // 受注日
    this.dateInfo = getOneMonthAgoArray();

    this.searchClick();
  },

  methods: {
    searchClick() {
      this.loading = true;

      if (this.dateLabel === "1") {
        this.allOrderInfo.aodDate = this.dateInfo;
        this.allOrderInfo.cusDeliveryDate = null;
      } else {
        this.allOrderInfo.cusDeliveryDate = this.dateInfo;
        this.allOrderInfo.aodDate = null;
      }

      this.allOrderInfo.quoteNo = this.allOrderInfo.quoteNo.trim();

      this.getAllOrderInfo(this.allOrderInfo);
    },

    // 一括手配画面情報の取得
    getAllOrderInfo(data) {
      commonApi(httpApi.GetAddAllOrderInfo, data)
        .then((res) => {
          // データの読み込
          this.dataProcess(res);
        })
        .catch((err) => {
          this.dataProcess(err.data.Data);

          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // データの読み込
    dataProcess(data) {
      this.aodConnecterNameList = data.UserNames;
      this.transMethodList = data.TransMethodList;

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      this.destinationList = data.DestinationPortList;
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
      this.supInfoList = data.SupInfoList;
      this.aodQuoteTypeList = data.AodQuoteTypeList;

      this.getAbleList();
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 納期の列幅フラグ（true:増加）
      var cusDeliveryDateChangeWidth = false;
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      data.SearchAddAllOrderDtos.map((item, index) => {
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //得意先納期
        if (item.aobCusDeliveryDateMin == item.aobCusDeliveryDateMax) {
          item.aobCusDeliveryDate = item.aobCusDeliveryDateMin;
        } else {
          //得意先納期の列幅フラグ（true:増加）
          cusDeliveryDateChangeWidth = true;
          item.aobCusDeliveryDate =
            item.aobCusDeliveryDateMin + "～" + item.aobCusDeliveryDateMax;
        }
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        item.orderDate = formatDateToString(new Date());

        item.orderConnecterName = this.aodConnecterNameList.some(
          (obj) => obj.UserId === localStorage.getItem(FINAL_STR.USER_ID)
        )
          ? localStorage.getItem(FINAL_STR.USER_ID)
          : // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
            // 担当者取得
            // "";
            getUserInfo().UserId;
        // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
        if (
          FACTORY_KBN_DALIAN === item.supFactoryKbn &&
          QUPTE_TYPE_CHANGE !== item.aodQuoteType
        ) {
          item.transMethod = "1";
        }
        item.index = index;
      });
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 納期の列幅フラグ（true:増加）
      this.columns = this.columns.map((col) => {
        if (col.prop === "aobCusDeliveryDate") {
          return { ...col, width: cusDeliveryDateChangeWidth ? 200 : 100 };
        }
        return col;
      });
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      // this.generateColumns();

      this.addAllOrderInfoTable = data.SearchAddAllOrderDtos;

      if (this.addAllOrderInfoTable.length > 0) {
        this.btnClickFlg = false;
      }

      // //列幅の設定
      // setColumnWidth(this.columns, this.addAllOrderInfoTable);

      // 読み込み回数 = 1
      if (this.numLoads == 1) {
        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.addAllOrderInfoTable)
        );

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    // セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 輸送方式を選択する必要がない場合
      if (
        column.property == "transMethod" &&
        !(row.supFactoryKbn === "1" && row.aodQuoteType !== "3")
      ) {
        return;
      }
      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      //目的港を選択する必要がない場合
      if (
        column.property == "destPortCode" &&
        !(row.supFactoryKbn === "1" && row.aodQuoteType !== "3" && row.transMethod == "2")
      ) {
        return;
      }
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      if (
        this.columnEditable.includes(column.property) ||
        (column.property && column.property.toString().includes("newColumn"))
      ) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
    },

    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },

    // 选中的行数据
    handleRowClick(row) {
      this.currentCell = row;
    },

    // 使用可能な担当者リストの取得
    getAbleList() {
      // 担当者リスト
      this.aodConnecterNameList = getAbleUserInfoList(
        this.aodConnecterNameList,
        this.allOrderInfo.aodConnecterName
      );

      // 仕入先リスト
      this.supInfoList = getAbleSupplierInfoList(
        this.supInfoList,
        this.allOrderInfo.supInfoCode
      );

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      // 目的港リスト
      this.destinationList = getAbleDestinationList(
        this.destinationList,
        ""
      );
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
    },

    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;

      if (val.indexOf("sendBasic") !== -1) {
        //基本情報のheight
        this.basicHeight = DIALOG_LINE_HEIGHT * 2.5;

        //基本情報のheight
        this.basicButtonHeight = DIALOG_LINE_HEIGHT;

        //合計情報のheight
        this.bottomHeight = DIALOG_LINE_HEIGHT * 1;

        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          DIALOG_LINE_HEIGHT * 1,
          DIALOG_LINE_HEIGHT * 2,
          40
        );
      } else {
        //基本情報のheight
        this.basicHeight = DIALOG_LINE_HEIGHT;

        //基本情報のheight
        this.basicButtonHeight = DIALOG_LINE_HEIGHT;

        //合計情報のheight
        this.bottomHeight = DIALOG_LINE_HEIGHT * 1;

        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          DIALOG_LINE_HEIGHT,
          DIALOG_LINE_HEIGHT,
          17
        );
      }

      //列の幅
      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //「確定」ボタン
    checkConfirm() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      let data = this.$refs.addAllOrderInfoTable.selection;

      if (data.length == 0) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });

        return;
      }
      // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 start↓
      else {
        for (var i = 0; i < data.length; i++) {
          if (this.isEmptyOrNull(data[i].deliveryDate)) {
            Modal.showWarning(
              "",
              "見積No.「" +
                data[i].aobQuoteNo +
                "」の" +
                t("message.ORDER.DUE_DATE_CHECK"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return;
          }

          // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 end↑
          //ミスミ連携番号が空、再確認してください
          if (data[i].aodMsmNoCheck === STR_ONE) {
            Modal.showWarning(
              "",
              "見積No.「" +
                data[i].aobQuoteNo +
                "」の" +
                t("message.ORDER.MSM_NO_CHECK"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return;
          }
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓

          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // 得意先納期　＜　仕入先納期　のチェックの追加
          if (
            new Date(data[i].aobCusDeliveryDateMin) <=
            new Date(data[i].deliveryDate)
          ) {
            Modal.showWarning(
              "",
              "見積No.「" +
                data[i].aobQuoteNo +
                "」の" +
                t("message.ACCEPT_ORDER.DUE_DATE_COMPARE_CHECK"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return;
          }
          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 目的港の追加
          // 輸送方式が「船便」、目的港が空の場合、メッセージ「目的港を選択してください」を表示する.
           if (data[i].transMethod == NUM_TWO && this.isEmptyOrNull(data[i].destPortCode)) {
            Modal.showWarning(
              "",
              "見積No.「" +
                data[i].aobQuoteNo +
                "」の" +
                t("message.ORDER.DESTINATION_PORT_CHECK"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return;
          }
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        }
      }

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      this.creatRequestData();
    },
    createDataCheck() {},

    // 請求情報の新規作成
    creatRequestData() {
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      if (!this.loading) {
        this.loading = true;
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      var result = "";
      commonApi(httpApi.CreatAddAllOrderInfo, this.currentCell)
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));

          this.$emit("ok", result);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        })
        .finally(() => {
          if (this.loading) {
            this.loading = false;
          }
        });
    },

    // クリアボタン
    clearClick() {
      this.allOrderInfo.cusInfo = "";
      this.allOrderInfo.cusInfoCode = "";
    },

    // 運送状態追加
    generateColumns() {
      // 運送状態
      let tranInfo = {
        prop: "transMethod",
        label: t("resource.ADD_ALL_ORDER_INFO.TRANS_METHOD"),
        minWidth: t("widgetSize.tableCommon.width150"),
        width: t("widgetSize.tableCommon.width150"),
        class: "cell_txt_left",
        overflowTooltip: false,
      };

      let haveTran = this.columns.findIndex(
        (obj) => obj.prop === "transMethod"
      );

      // 画面状態：true:新規　false:編集
      let insertIndex = this.columns.findIndex(
        (obj) => obj.prop === "orderConnecterName"
      );

      if (QUPTE_TYPE_CHANGE !== this.allOrderInfo.aodQuoteType) {
        if (insertIndex !== -1 && haveTran === -1) {
          this.columns.splice(insertIndex + 1, 0, tranInfo);
        }
      } else {
        this.columns.splice(insertIndex + 1, 1);
      }
    },

    //参照ボタン
    customerReferenceClick() {
      var arr = this.allOrderInfo.cusInfo?.split(":");
      var sbCusCode = arr?.length > 0 ? arr[0] : "";

      ShowCustomerReferenceDialog(
        { cusCode: sbCusCode },
        t("resource.numberEditInfo.customerReferenceView"),
        (target) => {
          if (!!target) {
            this.allOrderInfo.cusInfo = target;
            var arr = this.allOrderInfo.cusInfo?.split(":");
            this.allOrderInfo.cusInfoCode = arr?.length > 0 ? arr[0] : "";
            // this.getCusCalculateDateProc();
          }
        }
      );
    },

    handleRadioChange(newValue) {
      // 你可以根据 newValue 执行不同的操作
      if (newValue === "1") {
        this.dateInfo = getOneMonthAgoArray();
      } else if (newValue === "2") {
        this.dateInfo = getNextMonthAgoArray();
      }
    },

    // ダイアログを閉じる
    onCancel() {
      if (!cmpDetailData(this.cmpDetailResult, this.addAllOrderInfoTable)) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 start↓
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 end↑

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.requestInfoTable);
    },

    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
    // 目的港の追加
    onDestPortCodeChange(row, value) {
      if (value != NUM_TWO) {
        row.destPortCode = "";
      }
    }
    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 240px;
}

/* 设置按钮的背景颜色 */
.el-button.button-default.custom-button.el-button--default {
  background-color: #ffffff; /* 你想要的背景颜色 */
  height: 27px;
  padding-top: 6.5px;
  border-radius: 1;
}
.el-input__prefix {
  display: none !important;
}
.button-wrapper {
  margin-left: 30px;
}
</style>
